<div class="spinner-wrapper projekt">
    <mat-spinner></mat-spinner>
</div>
